// SV-slug → EN-slug och vice versa. Används av LanguageSwitcher för att
// hoppa mellan språkversioner av samma sida, av sitemap för hreflang, och
// av LocaleProvider för att hitta canonical/alternate.
//
// Lägg endast in sidor som faktiskt har en EN-mirror under /en/.
// När mer innehåll översätts: lägg till parets URL här OCH i EN_AVAILABLE_PATHS.

export type RoutePair = { sv: string; en: string };

export const ROUTE_PAIRS: RoutePair[] = [
  { sv: "/", en: "/en" },
  // Phase 1: legacy engelska landingssidor lever kvar under nytt /en-prefix
  // men hreflang pekar på de nya, kanoniska EN-sidorna (definierade nedan).
  { sv: "/produktionsbolag/stockholm", en: "/en/video-agency-stockholm" },
  // Phase 2 Loop 1: core-sidor
  { sv: "/pulse", en: "/en/pulse" },
  { sv: "/prime", en: "/en/prime" },
  { sv: "/tjanster", en: "/en/services" },
  { sv: "/priser", en: "/en/pricing" },
  { sv: "/om-fenny", en: "/en/about" },
  { sv: "/karriar", en: "/en/careers" },
  // Phase 2 Loop 2: resterande core-sidor
  { sv: "/kontakt", en: "/en/contact" },
  { sv: "/process", en: "/en/process" },
  { sv: "/case", en: "/en/work" },
  { sv: "/varfor-film", en: "/en/why-video" },
  { sv: "/kunskap", en: "/en/knowledge" },
  // Phase 3 Loop 3: formatsidor (A1)
  { sv: "/reklamfilm", en: "/en/commercials" },
  { sv: "/foretagsfilm", en: "/en/corporate-video" },
  { sv: "/varumarkesfilm", en: "/en/brand-film" },
  { sv: "/produktfilm", en: "/en/product-video" },
  { sv: "/rekryteringsfilm", en: "/en/recruitment-video" },
  { sv: "/utbildningsfilm", en: "/en/training-video" },
  { sv: "/eventfilm", en: "/en/event-film" },
  { sv: "/dokumentarfilm", en: "/en/documentary" },
  { sv: "/imagefilm", en: "/en/image-film" },
  { sv: "/kampanjfilm", en: "/en/campaign-film" },
  { sv: "/instruktionsfilm", en: "/en/instructional-video" },
  { sv: "/internkommunikation-film", en: "/en/internal-communication-video" },
  { sv: "/kundcase-film", en: "/en/customer-story-video" },
  { sv: "/testimonial-film", en: "/en/testimonial-video" },
  // Phase 3 Loop 4: tekniker + kanal-format (A2 + A3)
  { sv: "/3d-animation", en: "/en/3d-animation" },
  { sv: "/motion-graphics", en: "/en/motion-graphics" },
  { sv: "/b-roll-inspelning", en: "/en/b-roll" },
  { sv: "/livesandning", en: "/en/live-streaming" },
  { sv: "/aftermovie", en: "/en/aftermovie" },
  { sv: "/podcast-video", en: "/en/podcast-video" },
  { sv: "/film-for-instagram", en: "/en/video-for-instagram" },
  { sv: "/film-for-linkedin", en: "/en/video-for-linkedin" },
  { sv: "/film-for-tiktok", en: "/en/video-for-tiktok" },
  { sv: "/film-for-youtube", en: "/en/video-for-youtube" },
  { sv: "/sociala-medier-film", en: "/en/social-media-video" },
  // Phase 3 Loop 5: tjänsteöversikter (A4) + pris/jämför (A5)
  { sv: "/filmproduktion", en: "/en/film-production" },
  { sv: "/videoproduktion", en: "/en/video-production" },
  { sv: "/filmbyra", en: "/en/film-agency" },
  { sv: "/videobyra", en: "/en/video-agency" },
  { sv: "/reklamfilmsbyra", en: "/en/ad-agency" },
  { sv: "/contentbyra", en: "/en/content-agency" },
  { sv: "/filmproducent", en: "/en/film-producer" },
  { sv: "/employer-branding-film", en: "/en/employer-branding-video" },
  { sv: "/filmabonnemang", en: "/en/video-subscription" },
  { sv: "/film-pa-prenumeration", en: "/en/subscription-video" },
  { sv: "/jamfor/pulse-vs-prime", en: "/en/pulse-vs-prime" },
  { sv: "/jamfor/filmbyra-vs-frilansare", en: "/en/agency-vs-freelancer" },
  { sv: "/jamfor/filmabonnemang-vs-projektfilm", en: "/en/subscription-vs-project" },
  { sv: "/jamfor/inhouse-vs-filmbyra", en: "/en/inhouse-vs-agency" },
  { sv: "/vad-kostar-en-reklamfilm", en: "/en/what-does-a-commercial-cost" },
  { sv: "/vad-kostar-en-foretagsfilm", en: "/en/what-does-a-corporate-video-cost" },
  { sv: "/hur-lang-ska-en-reklamfilm-vara", en: "/en/how-long-should-a-commercial-be" },
  { sv: "/film-pris-kalkyl", en: "/en/video-price-calculator" },
  // Phase 3 Loop 6: industries (D) + misc (A6)
  { sv: "/branscher/bygg", en: "/en/industries/construction" },
  { sv: "/branscher/e-handel", en: "/en/industries/ecommerce" },
  { sv: "/branscher/fastighet", en: "/en/industries/real-estate" },
  { sv: "/branscher/halsa", en: "/en/industries/health" },
  { sv: "/branscher/industri", en: "/en/industries/industry" },
  { sv: "/branscher/offentlig-sektor", en: "/en/industries/public-sector" },
  { sv: "/branscher/restaurang", en: "/en/industries/restaurant" },
  { sv: "/branscher/saas", en: "/en/industries/saas" },
  { sv: "/faq", en: "/en/faq" },
  { sv: "/fragor", en: "/en/questions" },
  { sv: "/branscher/video-for-b2b", en: "/en/video-for-b2b" },
  { sv: "/branscher/video-for-saljteam", en: "/en/video-for-sales-teams" },
  { sv: "/branscher/video-for-marknadsavdelningar", en: "/en/video-for-marketing-teams" },
  { sv: "/branscher/video-for-tillvaxtbolag", en: "/en/video-for-growth-companies" },
  { sv: "/ordlista", en: "/en/glossary" },
  { sv: "/partners", en: "/en/partners" },
  { sv: "/press", en: "/en/press" },
  { sv: "/for-journalister", en: "/en/for-journalists" },
  { sv: "/integritet", en: "/en/privacy" },
  { sv: "/press/reklamfilm-2026-rapport", en: "/en/press/commercial-2026-report" },
  // Heritage
  { sv: "/heritage", en: "/en/heritage" },
  { sv: "/heritage/livsberattelser", en: "/en/heritage/livsberattelser" },
  { sv: "/heritage/kunskapsarv", en: "/en/heritage/kunskapsarv" },
  // Foto
];

const svToEn = new Map(ROUTE_PAIRS.map((p) => [p.sv, p.en]));
const enToSv = new Map(ROUTE_PAIRS.map((p) => [p.en, p.sv]));

/**
 * Lista över faktiskt byggda engelska routes. Används av switchern för att
 * undvika 404 när användaren byter språk på en sida som inte är översatt än.
 */
export const EN_AVAILABLE_PATHS = new Set<string>([
  "/en",
  "/en/video-agency-stockholm",
  "/en/film-production-sweden",
  "/en/pulse",
  "/en/prime",
  "/en/services",
  "/en/pricing",
  "/en/about",
  "/en/careers",
  "/en/contact",
  "/en/process",
  "/en/work",
  "/en/why-video",
  "/en/knowledge",
  "/en/commercials",
  "/en/corporate-video",
  "/en/brand-film",
  "/en/product-video",
  "/en/recruitment-video",
  "/en/training-video",
  "/en/event-film",
  "/en/documentary",
  "/en/image-film",
  "/en/campaign-film",
  "/en/instructional-video",
  "/en/internal-communication-video",
  "/en/customer-story-video",
  "/en/testimonial-video",
  // Loop 4
  "/en/3d-animation",
  "/en/motion-graphics",
  "/en/b-roll",
  "/en/live-streaming",
  "/en/aftermovie",
  "/en/podcast-video",
  "/en/video-for-instagram",
  "/en/video-for-linkedin",
  "/en/video-for-tiktok",
  "/en/video-for-youtube",
  "/en/social-media-video",
  // Loop 5
  "/en/film-production",
  "/en/video-production",
  "/en/film-agency",
  "/en/video-agency",
  "/en/ad-agency",
  "/en/content-agency",
  "/en/film-producer",
  "/en/employer-branding-video",
  "/en/video-subscription",
  "/en/subscription-video",
  "/en/pulse-vs-prime",
  "/en/agency-vs-freelancer",
  "/en/subscription-vs-project",
  "/en/inhouse-vs-agency",
  "/en/what-does-a-commercial-cost",
  "/en/what-does-a-corporate-video-cost",
  "/en/how-long-should-a-commercial-be",
  "/en/video-price-calculator",
  // Loop 6
  "/en/industries/construction",
  "/en/industries/ecommerce",
  "/en/industries/real-estate",
  "/en/industries/health",
  "/en/industries/industry",
  "/en/industries/public-sector",
  "/en/industries/restaurant",
  "/en/industries/saas",
  "/en/faq",
  "/en/questions",
  "/en/video-for-b2b",
  "/en/video-for-sales-teams",
  "/en/video-for-marketing-teams",
  "/en/video-for-growth-companies",
  "/en/glossary",
  "/en/partners",
  "/en/press",
  "/en/for-journalists",
  "/en/privacy",
  "/en/reports/commercial-2026",
  "/en/press/commercial-2026-report",
  // Heritage
  "/en/heritage",
  "/en/heritage/livsberattelser",
  "/en/heritage/kunskapsarv",
  // Foto
]);

// Slug-bevarande dynamiska routes: blog/$slug etc. delar slug mellan SV och EN
// (samma rad i DB, AI-översätter EN on-the-fly).
const DYNAMIC_PAIRS: Array<{ sv: string; en: string }> = [
  { sv: "/kunskap/", en: "/en/knowledge/" },
  { sv: "/fragor/", en: "/en/questions/" },
];

export function hasEnglishMirror(svPath: string): boolean {
  if (svToEn.has(svPath)) return true;
  return DYNAMIC_PAIRS.some((p) => svPath.startsWith(p.sv));
}

export function toEnPath(svPath: string): string {
  if (svToEn.has(svPath)) return svToEn.get(svPath)!;
  for (const p of DYNAMIC_PAIRS) {
    if (svPath.startsWith(p.sv)) return p.en + svPath.slice(p.sv.length);
  }
  // Saknar översättning → fall tillbaka till engelska startsidan i stället för 404.
  return "/en";
}

export function toSvPath(enPath: string): string {
  if (enToSv.has(enPath)) return enToSv.get(enPath)!;
  if (enPath === "/en") return "/";
  for (const p of DYNAMIC_PAIRS) {
    if (enPath.startsWith(p.en)) return p.sv + enPath.slice(p.en.length);
  }
  if (enPath.startsWith("/en/")) {
    // Hellre /en → / än att gissa fel slug och 404:a.
    return "/";
  }
  if (enPath.startsWith("/english/")) return "/";
  return enPath;
}

export function detectLocale(pathname: string): "sv" | "en" {
  if (pathname === "/en" || pathname.startsWith("/en/")) return "en";
  if (pathname.startsWith("/english/")) return "en";
  return "sv";
}
